<template>
    <div v-if="notice.title != undefined">
        <div class="col-md-8 col-sm-12 container">
            <div class="spacer" data-pgc="spacer"></div>
            <h1 class="h2">{{notice.title}}</h1>
            <p class="small">Publicado {{notice.createdAt | moment("from") }}</p>
            <div class="mt-n3 mb-1">
                <div class="badge badge-pill badge-info mr-1" v-for="category in notice.categories" :key="category">{{category}}</div>
            </div>

            <div :style="{'background-image':`url(${notice.thumbnail})`}" style="width: 100%;height: 0;padding-bottom: 50%;background-size: contain;background-repeat: no-repeat;background-position: center;"></div>

            <article class="lead mt-3 notice" v-html="notice.description">
            </article>
            <Notices :inSection="true" :limit="6" />
        </div>
        <Contact />
    </div>
    <div v-else class="min-vh-100">

    </div>
</template>

<script>
import Notices from '@/components/Notices'
import Contact from '@/components/Contact'
export default {
    name: 'NoticeSingle',
    components:{
        Notices,
        Contact
    },

    props:{
        id:{
            type: String,
            required: true
        },
    },
    computed:{
        notice(){
            return this.$store.state.notice.currentNotice
        }
    },
    watch:{
        createdAt(current, old){
            if(current != old){
                this.$store.dispatch('notice/getNoticeById', this.id)
            }
        }
    },
    created(){
        this.$store.dispatch('notice/getNoticeById', this.id)
    },
    destroyed(){
        this.$store.commit('notice/setCurrentNotice', [])
    }
}

</script>